import { render, staticRenderFns } from "./MessageMyIcon.vue?vue&type=template&id=563b80da"
import script from "./MessageMyIcon.vue?vue&type=script&lang=js"
export * from "./MessageMyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports